import React, { useEffect } from "react";
import { FormLoginScheme } from "../../../Models/Schemas/form-login";
import { FORM_LOGIN } from "../../../Constants/Login";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import "./login.css";

const Login = () => {
  const showToast = useToast();

  const { fetchDataLogin, loading, error, resetError } = useStore();

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_LOGIN, FormLoginScheme);

  const submit = (e) => {
    if (e?.preventDefault) e.preventDefault();
    fetchDataLogin(values);
  };

  useEffect(() => {
    if (!error) return;

    const message =
      error instanceof Error
        ? error.message
        : error?.error || "Error desconocido";

    showToast("error", message);
    resetError();
  }, [error, resetError, showToast]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="login-wrapper">
      <div className="form-login">
        <div className="login-header">
          <img
            src="https://cms.qualityseal.com.mx/contenido/uploads/logo_0b73df3fcc.png"
            alt="Quality Seal"
            className="login-logo"
          />
          <h1>Empleados Quality Seal</h1>
        </div>

        <form className="login-form-fields" autoComplete="off" onSubmit={submit}>
          <Input
            mask=""
            value={values.nombre}
            label="Usuario"
            onChange={handleChange("nombre")}
            onBlur={handleBlur("nombre")}
            error={setErrorFormSimpleUtil(errors, touched, "nombre")}
            success={!setErrorFormSimpleUtil(errors, touched, "nombre")}
          />

          <Input
            value={values.password}
            label="Contraseña"
            onChange={handleChange("password")}
            onBlur={handleBlur("password")}
            error={setErrorFormSimpleUtil(errors, touched, "password")}
            success={!setErrorFormSimpleUtil(errors, touched, "password")}
            variant="Password"
          />

          <Button
            text="Entrar"
            color="green"
            fill
            action={submit}
            disabled={!isValid}
            classNames="login-btn"
          />
        </form>
      </div>
    </div>
  );
};

export default Login;